import React from 'react';

import InvestorBlock from '../InvestorBlock';

import styles from './ConferenceCalls.module.scss';

interface IProps {
  title: string;
  anchor: string;
  data: {
    title: string;
    description: string;
  };
  lang: string;
}

function ConferenceCalls(props: IProps) {
  const { title, anchor, data, lang } = props;

  return (
    <InvestorBlock title={title} anchor={anchor}>
      <div className={styles.container}>
        <h6 className={styles.title} dangerouslySetInnerHTML={{ __html: data.title }} />
        <div className={`lang_${lang}`} dangerouslySetInnerHTML={{ __html: data.description }} />
      </div>
    </InvestorBlock>
  );
}

export { ConferenceCalls };
